import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import actions from 'actions/formInstances'
import documentActions from 'actions/documents'
import formTemplateActions from 'actions/formTemplates'
import userActions from 'actions/users'
import Component from 'components/FormInstances/Print'

const mapStateToProps = (state, props) => ({ ...createAuthStateToProps(state, props) })

const mapDispatchToProps = {
  getSettings: actions.getSettings,
  getDocumentContents: documentActions.getContents,
  getFormTemplate: formTemplateActions.getItem,
  getUsers: userActions.getItems,
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)
